import { jsx as _jsx } from "react/jsx-runtime";
import { stackClasses } from '@mui/material';
import { StackStyled } from './Stack.styled';
const Stack = (props) => {
    return _jsx(StackStyled, { ...props });
};
export { Stack, stackClasses };
